import { render, staticRenderFns } from "./BackToApp.vue?vue&type=template&id=2c4accd2&"
import script from "./BackToApp.vue?vue&type=script&lang=js&"
export * from "./BackToApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports